import { Box } from '@mui/material';
import clientLogo from 'assets/ClientLogo.png';
import driveLogo from 'assets/DRIVEtoPROFIT_REVERSE.png';
import { CLIENT_ID } from 'shared/constants';

export function InsightLogo() {
    return (
        <Box
            component='img'
            sx={{ maxHeight: (theme) => theme.mixins.toolbar.minHeight }}
            src={driveLogo}
            alt='insight logo'
            />
            );
        }
        
export function ClientLogo() {
    return (
        <Box
            component='img'
            sx={{ maxHeight: (theme) => theme.mixins.toolbar.minHeight }}
            src={clientLogo}
            alt={`${CLIENT_ID} logo`}
        />
    );
}
